import { ExtendedRankSortQuestionType, ExtendedRatingQuestionType, QuestionType, RatingType } from '@empathy/survey/base';

import { NotepadQuestion } from '../models/notepad-model.model';

export class SurveyUtils {
  static questionFactory(questionId: string, type: QuestionType): NotepadQuestion {
    return {
      questionId,
      questionText: '',
      mandatoryInd: false,
      questionType: type,
      cards: [],
      options: [],
      otherOptionInd: false,
      randomizeOptionsInd: false,
      noneOptionInd: false,
      instructions: '',
      programmerNotes: ''
    };
  }

  static questionWithOptionsFactory(questionId: string, type: QuestionType): NotepadQuestion {
    return {
      questionId,
      questionText: '',
      mandatoryInd: false,
      questionType: type,
      cards: [],
      options: ['', ''],
      otherOptionInd: false,
      randomizeOptionsInd: false,
      noneOptionInd: false,
      instructions: '',
      programmerNotes: ''
    };
  }

  static questionCarouselFactory(questionId: string, type: QuestionType): NotepadQuestion {
    return {
      questionId,
      questionText: '',
      mandatoryInd: false,
      questionType: type,
      cards: [''],
      options: ['', ''],
      otherOptionInd: false,
      randomizeOptionsInd: false,
      noneOptionInd: false,
      instructions: '',
      programmerNotes: ''
    };
  }

  static questionNumericRatingFactory(questionId: string, _type: QuestionType): NotepadQuestion {
    return {
      questionId,
      questionText: '',
      mandatoryInd: false,
      questionType: ExtendedRatingQuestionType.RatingNumeric,
      cards: [],
      options: [],
      otherOptionInd: false,
      randomizeOptionsInd: false,
      noneOptionInd: false,
      instructions: '',
      programmerNotes: '',
      ratingType: RatingType.numeric
    };
  }

  static questionDescriptiveRatingFactory(questionId: string, _type: QuestionType): NotepadQuestion {
    return {
      questionId,
      questionText: '',
      mandatoryInd: false,
      questionType: ExtendedRatingQuestionType.RatingDescriptive,
      cards: [],
      options: [],
      otherOptionInd: false,
      randomizeOptionsInd: false,
      noneOptionInd: false,
      instructions: '',
      programmerNotes: '',
      ratingType: RatingType.descriptive
    };
  }

  static questionStarsRatingFactory(questionId: string, _type: QuestionType): NotepadQuestion {
    return {
      questionId,
      questionText: '',
      mandatoryInd: false,
      questionType: ExtendedRatingQuestionType.RatingStars,
      cards: [],
      options: [],
      otherOptionInd: false,
      randomizeOptionsInd: false,
      noneOptionInd: false,
      instructions: '',
      programmerNotes: '',
      ratingType: RatingType.stars
    };
  }

  static questionNumericRankSortFactory(questionId: string, _type: QuestionType): NotepadQuestion {
    return {
      questionId,
      questionText: '',
      mandatoryInd: false,
      questionType: ExtendedRankSortQuestionType.RankSortNumeric,
      cards: [],
      options: ['', ''],
      ranks: ['', ''],
      otherOptionInd: false,
      randomizeOptionsInd: false,
      noneOptionInd: false,
      instructions: '',
      programmerNotes: '',
      ratingType: RatingType.numeric
    };
  }

  static questionDescriptiveRankSortFactory(questionId: string, _type: QuestionType): NotepadQuestion {
    return {
      questionId,
      questionText: '',
      mandatoryInd: false,
      questionType: ExtendedRankSortQuestionType.RankSortDescriptive,
      cards: [],
      options: ['', ''],
      ranks: ['', ''],
      otherOptionInd: false,
      randomizeOptionsInd: false,
      noneOptionInd: false,
      instructions: '',
      programmerNotes: '',
      ratingType: RatingType.descriptive
    };
  }
}
